/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/senders`;

const state = {
    senders: [],     // this is array of string (names)
    senders_list: [], // this is array of objects
    senders_count: null,
    selectedSender: {}
};

const getters = {
    allSenders: state => state.senders,
    allSendersList: state => state.senders_list,
    totalSendersCount: state => state.senders_count,
    selectedSender: state => state.selectedSender
};

const actions = {
    async fetchAllSenders({ commit }, payload) {
        try {
            
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(url, { 
                headers: { 'x-drmms-token': authToken } 
            });
            commit('setSenders', response.data);
        } catch (err) {
            console.log(err);
        }
    },
    async createSender({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, { name: body.name, email: body.email, label: body.label }, { headers: { 'x-drmms-token': authToken } });
            console.log(response.data)
            commit('addNewSender', response.data);
            commit('setSelectedSender', response.data)
            return true;
        } catch (err) {
            return err
        }
    },
    async deleteSenders({ commit }, ids) {
        try {
            const authToken = localStorage.getItem('access_token');

            const response = await axios({
                method: 'delete',
                url,
                data: { ids },
                headers: { 'x-drmms-token': authToken }
            })

            commit('deleteSenders', ids);
        } catch (err) {
            console.log(err);
        }
    },
    async updateSender({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: 'put',
                url: `${url}/${body.id}`,
                headers: { 'x-drmms-token': authToken },
                data: { name: body.name, label: body.label, email: body.email }

            })
            commit('updateSenderDetails', body);
            return true;
        } catch (err) {
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 400) return { error: true, status: 500, message: 'Internal Server Error' };
            }
            console.log(err);
        }
    }
};

const mutations = {
    setSenders: (state, senders) => {
        const list = [];
        const data = [];
        senders.forEach(sender => {
            data.push(sender);
            list.push({
                ...sender,
                createdAt: moment(sender.createdAt).format('LLL'),
                updatedAt: moment(sender.updatedAt).format('LLL')
            })
        });
        state.senders = data
        state.senders_list = list;
    },
    addNewSender: (state, sender) => {
        state.senders_list.push(sender);
        state.senders.push(sender);
    },
    setSelectedSender: (state, sender)=> {
        state.selectedSender = sender
    },
    deleteSenders: (state, senders) => {
        let newSendersList = [];
        let newSenders = [];

        state.senders_list.forEach(element => {
            if (!senders.includes(element.id)) {
                newSendersList.push(element);
                newSenders.push(element.name);
            }
        });

        state.senders = newSenders;
        state.senders_list = newSendersList;
    },
    updateSenderDetails: (state, sender) => {
        let index = state.senders_list.findIndex((s) => s.id === sender.id);

        if (index !== -1) {
            state.senders_list[index].name = sender.name;
            state.senders[index] = sender.name;
            state.senders_list[index].email = sender.email;
            state.senders[index] = sender.email
            state.senders_list[index].label = sender.label;
            state.senders[index] = sender.label
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}